import { render, staticRenderFns } from "./NotificationMenuItem.vue?vue&type=template&id=4554f156&scoped=true&"
import script from "./NotificationMenuItem.vue?vue&type=script&lang=ts&"
export * from "./NotificationMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationMenuItem.vue?vue&type=style&index=0&id=4554f156&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4554f156",
  null
  
)

export default component.exports